// services/quotesApi.js
const localQuotes = [
  // Laser & Skin Confidence Quotes
  "Glow different. Go laser.-flawskin",
  "Confidence is smooth skin deep.-flawskin",
  "Smooth is powerful.-flawskin",
  "Hair today, gone tomorrow.-flawskin",
  "No fuzz, no stress.-flawskin",
  "Radiate confidence.-flawskin",
  "Glow up with laser love.-flawskin",
  "Invest in your skin.-flawskin",
  "Smooth skin, don’t care.-flawskin",
  "Zap the fuzz, not your vibe.-flawskin",
  "Self-care is laser care.-flawskin",
  "Flawless skin is a flex.-flawskin",
  "Be bare and bold.-flawskin",
  "Silky skin, stronger you.-flawskin",
  "Stay smooth, stay stunning.-flawskin",
  "Say goodbye to shaving.-flawskin",
  "Shine in your skin.-flawskin",
  "Slay with every session.-flawskin",
  "Your skin, your glow.-flawskin",
  "Smooth is a lifestyle.-flawskin",
  "Skin goals unlocked.-flawskin",
  "Effortless beauty is in.-flawskin",
  "Laser: your glow-up weapon.-flawskin",
  "No hair. No hassle.-flawskin",
  "Smoother skin, smoother life.-flawskin",
  "Zap it and own it.",
  "Beautiful skin starts here.-flawskin",
  "Shaving is so last season.-flawskin",
  "Glow now, not later.-flawskin",
  "Smooth legs, no stress.-flawskin",
  "Love the skin you’re in.-flawskin",
  "Skin like silk.-flawskin",
  "Live hair-free. Live happy.-flawskin",
  "Ditch the blade.-flawskin",
  "Silky smooth and unstoppable.flawskin",
  "Less hair, more glow.-flawskin",
  "From fuzz to flawless.-flawskin",
  "Reveal your radiance.-flawskin",
  "Laser up, level up.-flawskin",
  "Smooth skin is self-love.-flawskin",
  "You deserve this glow.-flawskin",
  "No pain, just power.-flawskin",
  "Confidence starts with skin.-flawskin",
  "Get smooth. Stay smooth.-flawskin",
  "You were born to glow.-flawskin",
  "Bare it with pride.-flawskin",
  "Smooth today, fierce forever.-flawskin",
  "Let your skin breathe.-flawskin",
  "It’s your smooth era.-flawskin",
  "Shave less, live more.-flawskin",
  "Be fierce. Be fuzz-free.-flawskin",
  "You glow, girl.-flawskin",
  "Feel the freedom of smooth.-flawskin",
  "Laser is luxury.-flawskin",
  "Flawless is the new normal.-flawskin",
  "Confidence is the glow-up.-flawskin",
  "Power up your skin.-flawskin",
  "This glow is laser-made.-flawskin",
  "Your skin, your rules.-flawskin",
  "Laser it. Love it.-flawskin",
  "Start fresh. Start smooth.-flawskin",
  "Less hair, more you.-flawskin",
  "Bare your beauty.-flawskin",
  "Glow hard or go home.-flawskin",
  "No stubble, no trouble.-flawskin",
  "The future is hair-free.-flawskin",
  "Silk skin starts here.-flawskin",
  "Because smooth is stunning.-flawskin",
  "Glow better. Go laser.-flawskin",
  "Say yes to smooth.-flawskin",
  "Because razors are rude.-flawskin",
  "Your glow-up begins now.-flawskin",
  "Laser hair? Don’t care.-flawskin",
  "Smooth is strength.-flawskin",
  "Embrace the glow.-flawskin",
  "Laser: the beauty shortcut.-flawskin",
  "No more razor drama.-flawskin",
  "Be smooth. Be you.-flawskin",
  "Silky skin, bold heart.-flawskin",
  "Skin you’ll love to show.-flawskin",
  "Go fuzz-free fearlessly.-flawskin",
  "Laser made me do it.-flawskin",
  "Confidence looks good on you.-flawskin",
  "Feel flawless every day.-flawskin",
  "Shine smooth. Shine strong.-flawskin",
  "Soft skin, hard confidence.-flawskin",
  "Let your skin steal the spotlight.-flawskin",
  "Uncover your smoothest self.-flawskin",
  "Less hair, more self-love.-flawskin",
  "Silky smooth, always in the mood.-flawskin",
  "Be smooth, be unstoppable.-flawskin",
  "Glow and let go — of razors.-flawskin",
  "More glow. Less grow.-flawskin",
  "Because beauty shouldn't be painful.-flawskin",
  "Effortless smooth, everyday mood.-flawskin",
  "Skin that’s always in.-flawskin",
  "Free your skin, free your spirit.-flawskin",
  "No bumps. Just brilliance.-flawskin",
  "Laser smooth, confidence approved.-flawskin",
  "Shave time. Laser more.-flawskin",
  "Smooth skin, sharp confidence.-flawskin",
  "Feel smooth. Look flawless.-flawskin",
  "Because your skin deserves peace.-flawskin",
  "Laser now. Love forever.-flawskin",
  "Confidence starts with a single zap.-flawskin"
];

export const fetchRandomQuote = () => {
  try {
    // Get random quote from local array
    const randomIndex = Math.floor(Math.random() * localQuotes.length);
    const content = localQuotes[randomIndex];
    
    return {
      content: content,
      author: "Flawskin Team",
      fullQuote: content
    };

  } catch (error) {
    console.log("Error getting quote, using fallback");
    return {
      content: "You're beautiful just as you are",
      author: "Flawskin Team",
      fullQuote: "You're beautiful just as you are"
    };
  }
};
